/**
 * @ngdoc directive
 * @name vue.directive:vPlayerRoll
 * This handles the embed player pre/post roll
 */

export default (vue) => {
    vue.ctx.scope[vue.exp].element = vue.el;
    vue.ctx.scope[vue.exp].ready();
};